import { useCallback } from "react";

import {
    InputWithTypeahead,
    TypeaheadOptionOrGroup,
} from "@impero-com/common/components/typeahead";
import {
    getLocalizedName,
    TimezoneKey,
} from "@impero-com/common/utils/timezone";

import { useTimezoneListQuery } from "./queries/useTimezoneListQuery";

function formatOption(timezoneName: TimezoneKey) {
    return getLocalizedName(timezoneName);
}

export interface TimezoneTypeaheadProps {
    id: string;
    value?: TimezoneKey;
    onSelect: (timezoneName: string) => void;
}

export const TimezoneTypeahead = ({
    id,
    value,
    onSelect,
}: TimezoneTypeaheadProps) => {
    const { data: timezones, status } = useTimezoneListQuery();
    const handleSearch = useCallback(
        (
            value: string,
            callback: (
                options: Array<TypeaheadOptionOrGroup<TimezoneKey>>
            ) => void
        ) => {
            if (status === "success" && value.length >= 3) {
                const lcValue = value.toLowerCase();
                callback(
                    timezones
                        .filter(
                            (timezone) =>
                                timezone.name.toLowerCase().indexOf(lcValue) >=
                                0
                        )
                        .map((timezone) => {
                            return {
                                type: "Option" as const,
                                value: timezone.name as TimezoneKey,
                            };
                        })
                        .slice(0, 10)
                );
            } else {
                callback([]);
            }
            return Promise.resolve();
        },
        [timezones, status]
    );

    return (
        <InputWithTypeahead<TimezoneKey>
            id={id}
            value={value}
            onSelect={onSelect}
            formatOption={formatOption}
            onSearch={handleSearch}
        />
    );
};
